// **************** ROUTE CONSTANT START **************************
// General Page Section
export const HOME_PAGE = '/';
export const AGENTS_PAGE = '/agents';

// Listing Single Page Section
export const LISTING_POSTS_PAGE = '/listing';
export const SINGLE_POST_PAGE = '/post';

// Agent Profile Page Section
export const AGENT_PROFILE_PAGE = '/profile';
export const AGENT_ACCOUNT_SETTINGS_PAGE = '/account-settings';
export const AGENT_PROFILE_EDIT_PAGE = '/edit';
export const AGENT_IMAGE_EDIT_PAGE = '/change-image';
export const AGENT_PASSWORD_CHANGE_PAGE = '/change-password';
export const AGENT_PROFILE_DELETE = '/delete';
export const AGENT_PROFILE_FAVOURITE = '/favourite-post';
export const AGENT_PROFILE_CONTACT = '/contact';
export const ADD_HOTEL_PAGE = '/add';
export const ADD_EVAL_PAGE = '/evaluation';

// Other Pages
export const PRICING_PLAN_PAGE = '/pricing-plan';
export const PRIVACY_PAGE = '/privacy';

//Evaluation 

export const EVALUATION_RESULT_PAGE = '/estimation';
export const SIGNIN_ESTIMATION_PAGE ='/connexion'
export const SIGNUP_ESTIMATION_PAGE ='/inscription'


// Login / Registation Page
// export const AUTHENTICATION_PAGE = '/user';
export const LOGIN_PAGE = '/login';
export const REGISTRATION_PAGE = '/registration';
export const REGISTRATION_PAGE2 = '/registration2';
export const CHANGE_PASSWORD_PAGE = '/change-password';
export const FORGET_PASSWORD_PAGE = '/forget-password';
export const ASSITANT_PAGE = '/zia';
// **************** ROUTE CONSTANT END **************************
